import type CurrencyCode from '@alltrails/types/CurrencyCode';
import { getPurchaseEventId, getSignupEventId, getTrialStartEventId } from './conversionsApi';

// Check for presence of oaiq in case of content blockers
const isOpenAiPixelUnavailable = () => {
  return typeof oaiq === 'undefined';
};

// https://developers.openai.com/ads/measurement-pixel#lead-generation-and-registration
export const trackCompleteRegistrationForOpenAi = (userId: number) => {
  if (isOpenAiPixelUnavailable()) {
    return;
  }

  oaiq(
    'measure',
    'registration_completed',
    {
      type: 'customer_action'
    },
    {
      event_id: getSignupEventId(userId)
    }
  );
};

// https://developers.openai.com/ads/measurement-pixel#subscription-and-trial-events
export const trackPurchaseForOpenAi = ({
  currencyCode,
  value,
  isTrial,
  recurlyPlanCode,
  subscriptionEventId
}: {
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  recurlyPlanCode?: string;
  subscriptionEventId?: number;
}) => {
  if (isOpenAiPixelUnavailable() || !subscriptionEventId) {
    return;
  }

  if (isTrial) {
    oaiq(
      'measure',
      'trial_started',
      {
        type: 'plan_enrollment',
        plan_id: recurlyPlanCode
      },
      {
        event_id: getTrialStartEventId(subscriptionEventId)
      }
    );
  } else {
    oaiq(
      'measure',
      'subscription_created',
      {
        type: 'plan_enrollment',
        plan_id: recurlyPlanCode,
        amount: value,
        currency: currencyCode
      },
      {
        event_id: getPurchaseEventId(subscriptionEventId)
      }
    );
  }
};
